import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../../../lib/apiClient';
import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'entry_date', label: 'Date' },
  { key: 'description', label: 'Description' },
  { key: 'debit', label: 'Debit', align: 'right', type: 'money' },
  { key: 'credit', label: 'Credit', align: 'right', type: 'money' },
  { key: 'balance', label: 'Balance', align: 'right', type: 'money' },
];

// Reached either directly (System > Reports > General Ledger Interface) with
// no account picked yet, or via a Trial Balance code drill-down carrying
// ?chart_of_account_id — see GroupedReportView.tsx.
export function AccountLedgerReport() {
  const [searchParams] = useSearchParams();
  const [accountOptions, setAccountOptions] = useState<ReportOption[]>([]);

  useEffect(() => {
    api.get<{ id: number; code: string; name: string }[]>('/chart-of-accounts').then((res) => {
      setAccountOptions(res.data.map((a) => ({ value: String(a.id), label: `${a.code} — ${a.name}` })));
    });
  }, []);

  return (
    <ReportView
      title="General Ledger"
      description="Every posted transaction for one account, in date order with a running balance."
      endpoint="/reports/gl/account-ledger"
      columns={COLUMNS}
      filters={['account', 'dateRange']}
      accountOptions={accountOptions}
      initialAccountId={searchParams.get('chart_of_account_id') ?? undefined}
      xlsx
    />
  );
}
